import React, { useState, useEffect } from "react";
import icons from "../../icons";
import { useDispatch, useSelector } from "react-redux";
import { aaaChecked } from "../../redux/reducers/ContrastSlice";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import Constants from "../../Constants";
import { UserIcon, logoutIcon } from "../../AppIcons";
import { rolePermissionSelected } from "../../redux/reducers/RolePermissionSlice";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { handleError } from "../../services/authApiRoutes/APImethods";

export default function Header() {
  const { t } = useTranslation();
  const translate = t;
  const [togglePop, togglePopoverBody] = useState(false);
  const navigate = useNavigate();
  const openUserDetail = (event) => { togglePop ? togglePopoverBody(false) : togglePopoverBody(true); };
  const userDetailRedux = useSelector((loginSessionDetail) => loginSessionDetail.loginSession).value;
  const dispatch = useDispatch();

  const userInitials =
    userDetailRedux !== undefined && userDetailRedux !== ""
      ? userDetailRedux.firstName.charAt(0).toUpperCase() +
      userDetailRedux.lastName.charAt(0).toUpperCase()
      : "NA";

  const userName = userDetailRedux.firstName + " " + userDetailRedux.lastName;

  const colorContrastStateRedux = useSelector((aaaChecked) => aaaChecked.contrast).value;

  const closeUserDetail = (event) => {
    if (event.keyCode === 27) {
      togglePopoverBody(false);
      $("#user-login").trigger("focus");
    }
  };

  if (colorContrastStateRedux) {
    document.body.classList.add("color-contrast");
  } else {
    document.body.classList.remove("color-contrast");
  }

  const handleModalFocus = (event) => {
    if (document.activeElement.id === 'FirstLink') {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        openUserDetail()
        $("#user-login").trigger("focus");
      }
    }
    if ($(window).width() > 769) {
      if (document.activeElement.id === 'logoutFocus') {
        if (event.key === Constants.TAB && !event.shiftKey) {
          event.preventDefault();
          $("#user-login").trigger("focus");
        }
      }
    }
  }

  function colorContrastAAA(e) {
    dispatch(aaaChecked(e.target.checked));
  }
  function colorContrastKeydown(e) {
    if (e.key === Constants.ENTER) {
      dispatch(aaaChecked(e.target.checked));
    }
  }

  const getPermissionRole = () => {
  
    getAxiosResponse(APIUrls.USER_PERMISSIONS)
    .then((res)=>{
        let permissions = res.data?.permissions ? res.data?.permissions : [];
        dispatch(rolePermissionSelected(permissions));
    }).catch(err => {
        handleError(err);
    })

  }

  useEffect(() => {
    getPermissionRole()
  },[]);

  function logout(e) {
    if (e.type === "click" || e.keyCode === 13) {
      navigate("/logout");
    }
    if ((e.keyCode === 9 && e.shiftKey === false) || e.keyCode === 40) {
      togglePopoverBody(false);
    }
  }

  const executeScroll = (e) => {
    if (e.key === "Enter") {
      togglePopoverBody(true);
    }
    if (e.keyCode === 27) {
      togglePopoverBody(false);
    }

  };

  return (
    <>
      <header id="openHeader-Menu" className="header flex-center" >

        <div className="logo">
          <Link to={"/finance/projects"} aria-label="home page">
            <img src={colorContrastStateRedux ? icons.LOGO_AA : icons.LOGO} alt="Logo" />
          </Link>
        </div>

        <div className="right-block flex-center visibleHidden "  >
          <div className="flex-center mobileShow" />
          <div className="flex-center">
            <div className="form-switch mar-top6">
              <input type="checkbox" id="switch" value="color-contrast" role="switch" className="switch" aria-label="Dark mode"
                onChange={colorContrastAAA} onKeyDown={(e) => colorContrastKeydown(e)} defaultChecked={colorContrastStateRedux} />
            </div>

            <div id="user-login" className={togglePop ? "user-login flex-center open" : "user-login flex-center"}
              role="button" aria-label={userName + " , User profile"}
              tabIndex="0" aria-expanded={togglePop} onClick={openUserDetail} onKeyDown={executeScroll}
              data-tour="user-profile" >
              <figure>
                <div className="profileImage">{userInitials}</div>
              </figure>
              <div className="user">
                <strong>{userName}</strong>
              </div>

              <div className="popover-body" onKeyDown={handleModalFocus}>
                <div className="triangle-with-shadow"></div>
                <div className="inner-popover" onKeyDown={(e) => { closeUserDetail(e); }} >
                  <div className="user-list">
                    <Link id="FirstLink" to="/finance/account-profile" >
                      {UserIcon}
                      <span>{translate("header.my_account")}</span>
                    </Link>
                  </div>

                  <div className="user-list mhide" onClick={(e) => { logout(e); }} onKeyDown={(e) => { logout(e); }} >
                    <Link to="#" aria-label="sign out" id="logoutFocus">
                      {logoutIcon}
                      <span>{translate("header.sign_out")}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}